<template>
  <el-tooltip class="item" :disabled="tooltipDisabledData" effect="dark" :content="tooltipContent" placement="top-start">
    <el-select class="check-all-select" v-bind="$attrs" v-model="dataValue" :multiple="multiple">
      <el-option v-if="multiple && quicklySelectAll && optionsData.length" key="val_select_all_of_workflow" label="全选" value="">
        <div class="div_aaaa" style="width: 100%" @click="handleClickInner">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll">
            全选
          </el-checkbox>
        </div>
      </el-option>
      <el-option v-for="item in optionsData" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled" />
    </el-select>
  </el-tooltip>
</template>

<script>
export default {
  name: 'CheckAllSelect',
  props: {
    value: {
      type: [Array, String, Number],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    // 支持全选-只有在multiple为true下生效
    quicklySelectAll: {
      type: Boolean,
      default: true
    },
    optionList: {
      type: Array,
      default: () => []
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    disabledKey: {
      type: String,
      default: 'disabled'
    }
  },
  data () {
    return {
      checkAll: false,
      isIndeterminate: false,
      dataValue: ''
    }
  },
  computed: {
    optionsData () {
      return this.optionList.map(item => {
        return {
          label: item[this.labelKey],
          value: item[this.valueKey],
          disabled: item[this.disabledKey] || false
        }
      })
    },
    // 除去 disabled 后可选的
    availableOptionsData () {
      return this.optionsData.filter(item => !item.disabled)
    },
    tooltipDisabledData () {
      return !this.tooltip || !this.value || (this.multiple && !this.value.length > 0)
    },
    tooltipContent () {
      if (!this.multiple) {
        return (this.optionsData.find(i => i.value === this.value) || {}).label || this.value
      } else {
        const arr = []
        this.value.forEach(key => {
          arr.push((this.optionsData.find(i => i.value === key) || {}).label || key)
        })
        return arr.join(',')
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (neeVal) {
        if (this.multiple) {
          let checkedCount = neeVal.length
          this.checkAll = checkedCount > 0 && checkedCount === this.availableOptionsData.length
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.availableOptionsData.length
        }
        this.dataValue = neeVal
      }
    },
    dataValue (newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    handleClickInner (e) {
      this.checkAll = !this.checkAll
      e.preventDefault()
      e.stopPropagation()
      this.$nextTick(() => {
        if (this.checkAll) {
          this.dataValue = [...(this.availableOptionsData.map(i => i.value) || [])]
        } else {
          this.dataValue = []
        }
      })
    }
  }
}
</script>

<style lang="scss">
.check-all-select {
  ::v-deep .el-input .el-input__inner {
    padding: 0 20px 0 10px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: normal;
    white-space: nowrap;
  }
}
</style>
